/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import ErrorIntl from '../errors/ErrorIntl';

class IntlMsg {
  constructor(intl, context = '') {
    this.intl = intl;
    this.context = context;
    this.errorIntl = new ErrorIntl(intl, context);
  }

  msgId(id, context = this.context) {
    let intlId = id;
    if (context !== '') {
      intlId = `${context}.${id}`;
    }
    return intlId;
  }

  msg(id, context = this.context) {
    const intlId = this.msgId(id, context);
    return this.intl.formatMessage({
      id: intlId,
      defaultMessage: intlId,
    });
  }

  errorMsg(error, context = this.context) {
    return this.errorIntl.msg(error, context);
  }

  globalMsg(id) {
    return this.msg(id, '');
  }
}

export default IntlMsg;




// WEBPACK FOOTER //
// ./src/utils/intl/IntlMsg.js